import React from 'react';

function Summary({ color = '#335B70', ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
            <path
                d="M8.5 9c.283 0 .52-.096.713-.287A.968.968 0 0 0 9.5 8a.968.968 0 0 0-.287-.713A.968.968 0 0 0 8.5 7a.968.968 0 0 0-.713.287A.968.968 0 0 0 7.5 8c0 .283.096.52.287.713.192.191.43.287.713.287zm0 4c.283 0 .52-.096.713-.287A.968.968 0 0 0 9.5 12a.968.968 0 0 0-.287-.713A.967.967 0 0 0 8.5 11a.967.967 0 0 0-.713.287A.968.968 0 0 0 7.5 12c0 .283.096.52.287.713.192.191.43.287.713.287zm0 4c.283 0 .52-.096.713-.288A.968.968 0 0 0 9.5 16a.968.968 0 0 0-.287-.713A.967.967 0 0 0 8.5 15a.967.967 0 0 0-.713.287A.968.968 0 0 0 7.5 16c0 .283.096.52.287.712.192.192.43.288.713.288zm-3 4c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 3.5 19V5c0-.55.196-1.02.588-1.413A1.926 1.926 0 0 1 5.5 3h11l5 5v11c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 19.5 21h-14zm0-2h14V9h-4V5h-10v14z"
                fill={color}
            />
        </svg>
    );
}

export default Summary;
